export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/programas.jpg',
	   "funcion": 'Entrega de tarjetas.',
		"url" : 'https://www.facebook.com/reel/1642851557846554',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/contraloriaccion.jpg',
	    "funcion": 'Contraloría en Acción.',
		"url" : 'https://www.facebook.com/share/v/1AdRFLMooN',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/60segundos.jpg',
	    "funcion": '60 segundos.',
		"url" : 'https://www.facebook.com/reel/2647681709006868',
	},

	{
		"nombre": "Noticias.",
		"imagen": 'noticias/buzón.jpg',
		"funcion": "Buzón Digital",
		"url": "https://buzondigitalcontraloria.hidalgo.gob.mx/"
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]